import {
  Backdrop,
  /* eslint-disable max-len */
  Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Select, Switch, TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  BuildingFetchService,
  FetchBranchService, FetchFacilitiyService, FetchLocationService, FloorfetchService, LabfetchService, UnblockUserService, UserAddService, UserUpdateService,
} from '../../services/LoginPageService';
import ApplicationStore from '../../utils/localStorageUtil';
import { AddUserValidate } from '../../validation/formValidation';
import NotificationBar from '../notification/ServiceNotificationBar';
import ConfirmPassword from './passwordConfirmComponent';
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
function UserModal({
  open, setOpen, isAddButton, userData, setRefreshData,
}) {
  const { userDetails } = ApplicationStore().getStorage('userDetails');
  const isSuperAdmin = userDetails ? userDetails.userRole === 'superAdmin' : true;
  const { userRole } = userDetails;
  const [id, setId] = useState('');
  const [empId, setEmployeeId] = useState('');
  const [email, setEmailId] = useState('');
  const [phoneNo, setPhone] = useState('');
  const [empRole, setRole] = useState(isSuperAdmin ? 'superAdmin' : 'User');
  const [empName, setFullName] = useState('');
  const [empNotification, setEmpNotification] = useState(false);
  const [companyCode, setCompanyCode] = useState('');
  const [location_id, setLocationId] = useState('');
  const [branch_id, setBranchId] = useState('');
  const [facility_id, setFacilityId] = useState('');
  const [building_id, setBuildingId] = useState('');
  const [floor_id, setFloorId] = useState('');
  const [lab_id, setLabId] = useState('');
  const [locationList, setLocationList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [buildingList, setBuildingList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [labList, setLabList] = useState([]);
  const [password, setPassword] = useState('');
  const [btnReset, setBtnReset] = useState(false);
  const [errorObject, setErrorObject] = useState({});
  const [backdrop, setBackdrop] = useState(false);

  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });

  useEffect(() => {
    if (userData) {
      setOpen(open);
      setBackdrop(true);
      loaddata();
    }
    if (isAddButton) {
      setBackdrop(false);
    }
  }, [userData, isAddButton]);

  const loaddata = () => {
    setBranchList([]);
    setFacilityList([]);
    setBuildingList([]);
    setFloorList([]);
    setLabList([]);
    setBranchId('');
    setFacilityId('');
    setBuildingId('');
    setFloorId('');
    setLabId('');
    setPassword(userData?.password ||  '');
    if (!isAddButton) {
      if (userData?.location_id) {
        setBackdrop(true);
        FetchLocationService((locationRespObj) => {
          locationHandleSuccess(locationRespObj);
          FetchBranchService({
            location_id: userData?.location_id,
          }, (branchRespObj) => {
            setLocationId(userData.location_id);
            branchHandleSuccess(branchRespObj);
            if (userData?.branch_id) {
              FetchFacilitiyService({
                location_id: userData?.location_id,
                branch_id: userData?.branch_id,
              }, (facilityRespObj) => {
                setBranchId(userData.branch_id);
                facilityHandleSuccess(facilityRespObj);
                if (userData?.facility_id) {
                  BuildingFetchService({
                    location_id: userData?.location_id,
                    branch_id: userData?.branch_id,
                    facility_id: userData?.facility_id,
                  },(buildingRespObj)=>{
                    setFacilityId(userData.facility_id);
                    buildingHandleSuccess(buildingRespObj);
                    if(userData?.building_id){
                      FloorfetchService({
                        location_id: userData?.location_id,
                        branch_id: userData?.branch_id,
                        facility_id: userData?.facility_id,
                        building_id: userData?.building_id,
                      },(floorRespObj)=>{
                        setBuildingId(userData.building_id);
                        floorHandleSuccess(floorRespObj);
                        if(userData?.floor_id){
                          LabfetchService({
                            location_id: userData?.location_id,
                            branch_id: userData?.branch_id,
                            facility_id: userData?.facility_id,
                            building_id: userData?.building_id,
                            floor_id: userData?.floor_id,
                          },(labRespObj)=>{
                            labHandleSuccess(labRespObj);
                            if(userData?.lab_id){
                              setLabId(userData.lab_id);
                              setBackdrop(false);
                            }
                          },locationHandleException);
                          setFloorId(userData.floor_id);
                        }
                        else{
                          setBackdrop(false);
                        }
                      }, locationHandleException);
                      setBuildingId(userData.building_id);
                    }
                    else{
                      setBackdrop(false);
                    }
                  },locationHandleException);
                }
                else{
                  setBackdrop(false);
                }
              }, locationHandleException);
            } else {
              setBackdrop(false);
            }
          }, locationHandleException);
        }, locationHandleException);
      } else {
        setBackdrop(false);
      }
    } else {
      FetchLocationService((locationRespObj) => {
        locationHandleSuccess(locationRespObj);
        setBranchList([]);
        setFacilityList([]);
        setBuildingList([]);
        setFloorList([]);
        setLabList([]);
        setBranchId('');
        setFacilityId('');
        setBuildingId('');
        setFloorId('');
        setLabId('');
      }, locationHandleException);
    }
    setId(userData?.id || '');
    setEmployeeId(userData?.employeeId || '');
    setEmailId(userData?.email || '');
    setPhone(userData?.phone || '');
    if (isSuperAdmin) {
      setRole(userData?.userRole || 'superAdmin');
    } else {
      setRole(userData?.userRole || 'User');
    }
    setEmpNotification(userData?.empNotification === 1 ? true : false);
    setFullName(userData?.fullName || '');
    setCompanyCode(userData?.companyCode || '');
    setLocationId(userData?.location_id || '');
    setBranchId(userData?.branch_id || '');
    setFacilityId(userData?.facility_id || '');
    setBuildingId(userData?.building_id || '');
    setFloorId(userData?.floor_id || '');
    setLabId(userData?.lab_id || '');
    setRole(userData?.userRole || '');
  };

  const validateForNullValue = (value, type) => {
    AddUserValidate(value, type, setErrorObject);
  };

  const handleSuccess = (resErrorObject) => {
    setNotification({
      status: true,
      type: 'success',
      message: resErrorObject.message,
    });
    setRefreshData((oldvalue) => !oldvalue);
    setTimeout(() => {
      setPassword('');
      handleClose();
      setOpen(false);
      setErrorObject({});
    }, 3000);
  };

  const handleException = (resErrorObject, errorMessage) => {
    setNotification({
      status: true,
      type: 'error',
      message: errorMessage,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isAddButton) {
      await UserAddService({
        userRole:empRole,
        employeeId:empId,
        email:email,
        phone:phoneNo,
        fullName:empName,
        password:password,

     }, handleSuccess, handleException);
    } else {
      await UserUpdateService({
        id:id,
        userRole:empRole,
        employeeId:empId,
        email:email,
        phone:phoneNo,
        fullName:empName,
        password:password,
       }, handleSuccess, handleException);
    }
  };

  // const passwordSubmit = async (e) => {
  //   e.preventDefault();
  //   UnblockUserService(
  //     { email, password, id },
  //     passwordValidationSuccess,
  //     passwordValidationException,
  //   );
  //   setBtnReset(false);
  // };
  const passwordValidationSuccess = (dataObject) => {
    setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    });
    setTimeout(() => {
      handleClose();
    }, 5000);
  };

  const passwordValidationException = (resErrorObject, errorMessage) => {
    setNotification({
      status: true,
      type: 'error',
      message: errorMessage,
    });
    setTimeout(() => {
      handleClose();
    }, 5000);
  };

  const handleClose = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };

  const locationHandleSuccess = (dataObject) => {
    setLocationList(dataObject.data);
    setBranchList([]);
    setFacilityList([]);
    setBuildingList([]);
    setFloorList([]);
    setLabList([]);
  };

  const locationHandleException = () => {};

  const branchHandleSuccess = (dataObject) => {
    setBranchList(dataObject.data);
    setFacilityList([]);
    setBuildingList([]);
    setFloorList([]);
    setLabList([]);
    setBranchId('');
    setFacilityId('');
    setBuildingId('');
    setFloorId('');
    setLabId('');
  };

  const branchHandleException = () => {};

  const facilityHandleSuccess = (dataObject) => {
    setFacilityList(dataObject.data);
    setBuildingList([]);
    setFloorList([]);
    setLabList([]);
    setFacilityId('');
    setBuildingId('');
    setFloorId('');
    setLabId('');
  };

  const facilityHandleException = () => {};

  const buildingHandleSuccess = (dataObject) =>{
    setBuildingList(dataObject.data);
    setFloorList([]);
    setLabList([]);
    setBuildingId('');
    setFloorId('');
    setLabId('');
  }

  const floorHandleSuccess = (dataObject) =>{
    setFloorList(dataObject.data);
    setLabList([]);
    setFloorId('');
    setLabId('');
  }

  const labHandleSuccess = (dataObject) =>{
    setLabList(dataObject.data);
    setLabId('');
    setBackdrop(false);
  }
  
  const onLocationChange = (location_id) => {
    setLocationId(location_id);
    if (location_id) {
      FetchBranchService({ location_id }, branchHandleSuccess, branchHandleException);
    } else {
      setBranchList([]);
      setFacilityList([]);
      setBuildingList([]);
      setFloorList([]);
      setLabList([]);
      setBranchId('');
      setFacilityId('');
      setBuildingId('');
      setFloorId('');
      setLabId('');
    }
  };

  const onBranchChange = (branch_id) => {
    setBranchId(branch_id);
    if (branch_id) {
      FetchFacilitiyService({ location_id, branch_id }, facilityHandleSuccess, facilityHandleException);
    } else {
      setFacilityList([]);
      setBuildingList([]);
      setFloorList([]);
      setLabList([]);
      setFacilityId('');
      setBuildingId('');
      setFloorId('');
      setLabId('');
    }
  };

  const onFacilityChange = (facility_id) => {
    setFacilityId(facility_id);
    if (facility_id) {
      BuildingFetchService({ location_id, branch_id, facility_id }, buildingHandleSuccess, locationHandleException);
    } else {
      setBuildingList([]);
      setFloorList([]);
      setLabList([]);
      setBuildingId('');
      setFloorId('');
      setLabId('');
    }
  };

  const onBuildingChange = (building_id) =>{
    setBuildingId(building_id);
    if (facility_id) {
      FloorfetchService({ location_id, branch_id, facility_id, building_id }, floorHandleSuccess, locationHandleException);
    } else {
      setFloorList([]);
      setLabList([]);
      setFloorId('');
      setLabId('');
    }
  }
  const onFloorChange = (floor_id) =>{
    setFloorId(floor_id);
    if (floor_id) {
      LabfetchService({ location_id, branch_id, facility_id, building_id, floor_id }, labHandleSuccess, locationHandleException);
    } else {
      setLabList([]);
      setLabId('');
    }
  }
  
  const onLabChange = (lab_id) =>{
    setLabId(lab_id);
  }

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { minWidth: '50%' } }}
      maxWidth="sm"
      open={open}
    >
      <DialogTitle style={{background:'#012738',color:'white'}}>
        {isAddButton ? 'Add User' : 'Edit User'}
      </DialogTitle>
      <DialogContent>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md  -space-y-px">
            <div className="rounded-md -space-y-px mb-2">
              <TextField
                sx={{ mb: 2, mt: 2 }}
                label="Employee Id"
                type="text"
                value={empId}
                variant="outlined"
                placeholder="Employee Id"
                className="mb-2 appearance-none rounded-none
                relative block w-full px-3 py-2 border border-gray-300
                placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none
                focus:ring-red-500 focus:border-red-500  sm:text-sm"
                required
                onBlur={() => validateForNullValue(empId, 'employeeId')}
                onChange={(e) => { setEmployeeId(e.target.value); }}
                autoComplete="off"
                error={errorObject?.employeeId?.errorStatus}
                helperText={errorObject?.employeeId?.helperText}
              />
            </div>
            <div className="rounded-md -space-y-px">
              <div className="mb-2">
                <TextField
                  sx={{ mb: 2 }}
                  label="Email Id"
                  type="email"
                  value={email}
                  variant="outlined"
                  placeholder="Email Id"
                  className="mb-2 appearance-none rounded-none relative
                  block w-full px-3 py-2 border border-gray-300 placeholder-gray-500
                  text-gray-900 rounded-t-md focus:outline-none focus:ring-red-500
                  focus:border-red-500  sm:text-sm"
                  required
                  onBlur={() => { validateForNullValue(email, 'email'); }}
                  onChange={(e) => { setEmailId(e.target.value); }}
                  autoComplete="off"
                  error={errorObject?.emailId?.errorStatus}
                  helperText={errorObject?.emailId?.helperText}
                />
              </div>
            </div>
            <div className="rounded-md -space-y-px">
              <div className="mb-2">
                <TextField
                  sx={{ mb: 2 }}
                  label="Password"
                  type="text"
                  value={password}
                  variant="outlined"
                  placeholder="Password"
                  className="mb-2 appearance-none rounded-none relative
                  block w-full px-3 py-2 border border-gray-300 placeholder-gray-500
                  text-gray-900 rounded-t-md focus:outline-none focus:ring-red-500
                  focus:border-red-500  sm:text-sm"
                  required
                
                  onChange={(e) => { setPassword(e.target.value); }}
                  autoComplete="off"
                  error={errorObject?.emailId?.errorStatus}
                  helperText={errorObject?.emailId?.helperText}
                />
              </div>
            </div>
            <div className="rounded-md -space-y-px">
              <div className="mb-2">
                <TextField
                  sx={{ mb: 2 }}
                  label="Phone"
                  type="number"
                  value={phoneNo}
                  variant="outlined"
                  placeholder="Phone number"
                  className="mb-2 appearance-none rounded-none relative block w-full px-3 py-2
                  border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                  focus:outline-none focus:ring-red-500 focus:border-red-500  sm:text-sm"
                  required
                  onBlur={() => validateForNullValue(phoneNo, 'phone')}
                  onChange={(e) => { setPhone(e.target.value); }}
                  autoComplete="off"
                  error={errorObject?.phone?.errorStatus}
                  helperText={errorObject?.phone?.helperText}
                />
              </div>
            </div>
            <div className="rounded-md -space-y-px">
              <div className="mb-2">
                <TextField
                  sx={{ mb: 2 }}
                  label="Full Name"
                  type="text"
                  value={empName}
                  variant="outlined"
                  placeholder="Full Name"
                  className="mb-2 appearance-none rounded-none relative block w-full px-3 py-2
                  border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                  focus:outline-none focus:ring-red-500 focus:border-red-500  sm:text-sm"
                  required
                  onBlur={() => validateForNullValue(empName, 'fullName')}
                  onChange={(e) => setFullName(e.target.value)}
                  autoComplete="off"
                  error={errorObject?.fullName?.errorStatus}
                  helperText={errorObject?.fullName?.helperText}
                />
              </div>
            </div>
            <div className="rounded-md -space-y-px">
              <div className="mb-2">
                <FormControl sx={{ mb: 2 }} fullWidth>
                  <InputLabel id="demo-simple-select-label">Role</InputLabel>
                  {isSuperAdmin
                    ? (
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={empRole}
                        label="Role"
                        onChange={(e) => {
                          setRole(e.target.value);
                        }}
                        disabled
                      >
                        <MenuItem value="superAdmin">Super Admin</MenuItem>
                      </Select>
                    )
                    : (
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={empRole}
                        disabled={userRole === 'Manager' && true}
                        label="Role"
                        onChange={(e) => {
                          setRole(e.target.value);
                        }}
                      >
                        <MenuItem value="Admin">Admin</MenuItem>
                        <MenuItem value="CRM">CRM</MenuItem>
                        <MenuItem value="Purchase">Purchase</MenuItem>
                        <MenuItem value="Invoice">Invoice</MenuItem>
                        <MenuItem value="Mgmt">Mgmt</MenuItem>
                        <MenuItem value="Dispatch ">Dispatch</MenuItem>
                        <MenuItem value="Dispatch Supervisor">Dispatch Supervisor</MenuItem>
                      </Select>
                    )}
                </FormControl>
              </div>
            </div>
            {/* {isSuperAdmin ? '' : 
              <div className="">
                <div className="">
                  <FormGroup sx={{ display: 'block' }}>
                    <FormControlLabel
                      control={(
                        <Switch
                        
                          checked={empNotification}
                          onChange={(e) => {
                            setEmpNotification(e.target.checked);
                          }}
                          color="warning"
                        />
                      )}
                      label="Enable Notification"
                    />
                  </FormGroup>
                </div>
              </div>
            }
            <div className="rounded-md -space-y-px float-right">
              {isAddButton ? ''
                : (
                  <Button
                    onClick={() => {
                      setBtnReset(true);
                    }}
                  >
                    Reset Password
                  </Button>
                )} */}

                 <div className="rounded-md -space-y-px float-right">
              <Button
                type="submit"
                disabled={
                  errorObject?.employeeId?.errorStatus
                  || errorObject?.emailId?.errorStatus
                  || errorObject?.phone?.errorStatus
                  || errorObject?.role?.errorStatus
                  || errorObject?.fullName?.errorStatus
                }
              >
                {isAddButton ? 'Add' : 'Update'}
              </Button>
              <Button
                onClick={() => {
                  setErrorObject({});
                  setBranchList([]);
                  setFacilityList([]);
                  setBuildingList([]);
                  setBranchId('');
                  setFacilityId('');
                  setBuildingId('');
                  setFloorId('');
                  setLabId('');
                  loaddata();
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
      {/* <ConfirmPassword
        open={btnReset}
        passwordSubmit={passwordSubmit}
        setConfirmPassword={setConfirmPassword}
        setBtnReset={setBtnReset}
      /> */}
      <NotificationBar
        handleClose={handleClose}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}

export default UserModal;
